"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWorkflowValidator = void 0;
const react_1 = require("react");
const WorkflowValidator_1 = require("../plugins/WorkflowValidator");
const Workflow_context_1 = require("../Workflow.context");
function useWorkflowValidator(context) {
    const { servicePlugins, transitionConditionPlugins } = (0, Workflow_context_1.useWorkflowContext)();
    const validatorRef = (0, react_1.useRef)(new WorkflowValidator_1.WorkflowValidator(servicePlugins, transitionConditionPlugins));
    const contextRef = (0, react_1.useRef)(context);
    contextRef.current = context;
    const [result, setResult] = (0, react_1.useState)({ isValidating: false });
    const validate = (0, react_1.useCallback)((config, includeValid = true) => __awaiter(this, void 0, void 0, function* () {
        setResult({ isValidating: true });
        const result = yield validatorRef.current.validate(config, contextRef.current, includeValid);
        setResult({ result, isValidating: false });
    }), []);
    return { result, validator: validatorRef.current, validate };
}
exports.useWorkflowValidator = useWorkflowValidator;
//# sourceMappingURL=useWorkflowValidator.js.map